import { useQuery } from "@tanstack/react-query";

import { classroomReferencesApi, classroomReferencesQueryKey } from "@/lib/api/classroomReferences";

/** One read of a course's references, shared by the tile and whatever must know whether it holds any. */
export function useClassroomReferences(courseId: string) {
  return useQuery({
    queryKey: classroomReferencesQueryKey(courseId),
    queryFn: () => classroomReferencesApi.get(courseId),
    retry: false,
  });
}
